import TaxCouponEntryPage from './TaxCouponEntryPage'

export default TaxCouponEntryPage
